import { ChevronRight } from "lucide-react";
import Link from "next/link";
import { FC } from "react";

interface ViewAllButtonProps {
  slug: string;
  onClick?: () => void;
}

const ViewAllButton: FC<ViewAllButtonProps> = ({ slug, onClick }) => {
  return (
    <Link
      href={slug}
      onClick={onClick}
      className="w-full group h-full rounded-lg flex flex-col items-center justify-center gap-6"
      style={{ background: "linear-gradient(to bottom, #6b7280, #9ca3af)" }}
    >
      <p className="text-xl text-white font-medium">Tümünü Gör</p>
      <div className="w-8 h-8 group-hover:scale-[1.05] transition-all duration-300 ease-in-out border border-white rounded-full flex items-center justify-center">
        <ChevronRight className="text-white" />
      </div>
    </Link>
  );
};

export default ViewAllButton;
